import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useAppThunkDispatch } from 'state/store';
import { getProjectId, setProjectId } from 'state/Project/projectSlice';
import { selectIsProjectSelected } from 'state/ProjectsList/export/exportSlice';
import { RootState } from 'state/store';
import { PATHS } from 'utils/constants';

export interface UseProjectTableRowProps {
  projectId: string;
}

interface UseProjectTableRowReturn {
  isProjectSelected: boolean;
  handleClickProjectRow: () => void;
}

export const useProjectTableRow: (
  params: UseProjectTableRowProps
) => UseProjectTableRowReturn = ({ projectId }) => {
  const dispatch = useAppThunkDispatch();
  const history = useHistory();
  const projectIdToEdit = useSelector(getProjectId);
  const isProjectSelected = useSelector((state: RootState) =>
    selectIsProjectSelected(state, projectId)
  );

  const openProjectPanel = useCallback(() => {
    dispatch(setProjectId(projectId));
  }, [dispatch, projectId]);

  const navigateToProjectDetailPage = useCallback(() => {
    history.push(`${PATHS.PROJECT_PAGE}/${projectId}`, {
      from: history.location.pathname,
    });
  }, [history, projectId]);

  const handleClickProjectRow = useCallback(() => {
    if (projectIdToEdit && projectIdToEdit !== projectId) {
      openProjectPanel();
    } else {
      navigateToProjectDetailPage();
    }
  }, [
    projectIdToEdit,
    projectId,
    openProjectPanel,
    navigateToProjectDetailPage,
  ]);

  return useMemo(
    () => ({ isProjectSelected, handleClickProjectRow }),
    [isProjectSelected, handleClickProjectRow]
  );
};
